import { render, staticRenderFns } from "./Release600.vue?vue&type=template&id=5cd77e70"
import script from "./Release600.vue?vue&type=script&lang=js"
export * from "./Release600.vue?vue&type=script&lang=js"
import style0 from "./Release600.vue?vue&type=style&index=0&id=5cd77e70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports